module.exports = __webpack_public_path__ + "static/media/navidad_checked.3a6f9e0f.svg";